/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventanswersanonymous2Inputs */

const en_eventanswersanonymous2 = /** @type {(inputs: Eventanswersanonymous2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymous: you only see numbers, never names.`)
};

const de_eventanswersanonymous2 = /** @type {(inputs: Eventanswersanonymous2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonym: du siehst nur Zahlen, nie Namen.`)
};

/**
* | output |
* | --- |
* | "Anonymous: you only see numbers, never names." |
*
* @param {Eventanswersanonymous2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventanswersanonymous2 = /** @type {((inputs?: Eventanswersanonymous2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventanswersanonymous2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventanswersanonymous2(inputs)
	return de_eventanswersanonymous2(inputs)
});
export { eventanswersanonymous2 as "eventAnswersAnonymous" }